import _ from 'lodash';
import { Validator } from 'modules/core';

function validateProfileDetails(values) {
  const firstNameError = Validator.validateName(values.firstName, 'First name');
  const lastNameError = Validator.validateName(values.lastName, 'Last name');
  const titleError =
    Validator.validateUserText(values.title, 'Professional Tagline/Title') ||
    Validator.validateStringLength(
      values.title,
      { min: 2 },
      'Professional Tagline/Title',
    );
  const biographyError =
    Validator.validateUserText(values.biography, 'Biography') ||
    Validator.validateStringLength(values.biography, { min: 50 }, 'Biography');

  return {
    ...(firstNameError && { firstName: firstNameError }),
    ...(lastNameError && { lastName: lastNameError }),
    ...(titleError && { title: titleError }),
    ...(biographyError && { biography: biographyError }),
  };
}

function validateAgencyDetails(values) {
  const agencyNameError =
    Validator.validateUserText(values.agencyName, 'Agency name') ||
    Validator.validateStringLength(
      values.agencyName,
      { max: 250 },
      'Agency name',
    );
  const cityError = Validator.validateUserText(values.city, 'City');
  const zipError = Validator.validateUserText(values.zipCode, 'Zip code');
  const aboutAgencyError = Validator.validateUserText(
    values.aboutAgency,
    'About my agency',
  );

  return {
    ...(agencyNameError && { agencyName: agencyNameError }),
    ...(cityError && { city: cityError }),
    ...(zipError && { zipCode: zipError }),
    ...(aboutAgencyError && { aboutAgency: aboutAgencyError }),
  };
}

function validateSocialLinks(agent) {
  const socialMediaLinks = _.pick(agent, [
    'linkedinLink',
    'instagramLink',
    'twitterLink',
    'facebookLink',
  ]);

  return _.reduce(
    socialMediaLinks,
    (result, link, name) => {
      if (_.isEmpty(link)) {
        return result;
      }
      const socialMedia = name.slice(0, -4); // instagramLink => instagram
      const linkError = Validator.validateLink(link, socialMedia);
      if (linkError) {
        // eslint-disable-next-line no-param-reassign
        result[name] = linkError;
      }
      return result;
    },
    {},
  );
}

function validateClientInvite(values) {
  const { email } = values;
  const inviteEmailError = Validator.isEmail(email);
  return {
    ...(inviteEmailError && { email: inviteEmailError }),
  };
}

export default {
  validateSocialLinks,
  validateAgencyDetails,
  validateProfileDetails,
  validateClientInvite,
};
